<script setup lang="ts">
import { EntityWithCommentType, PtwCommentDto } from '@/api/generator';
import Tile from '@/components/comments/CommentTile.vue';
import { onMounted, ref } from 'vue';
import useCrudForComments from './useCrudForComments';

const props = defineProps<{
  id: string | number;
  entityWithCommentType: EntityWithCommentType;
}>();

const comments = ref<PtwCommentDto[] | undefined>(undefined);

const { getCommentsForEnity } = useCrudForComments(props.id, props.entityWithCommentType);

async function updateComments() {
  comments.value = await getCommentsForEnity();
}

const emits = defineEmits<{
  change: [comments: PtwCommentDto[] | undefined];
}>();

async function change() {
  await updateComments();
  emits('change', comments.value);
}

onMounted(async () => {
  await updateComments();
});
</script>

<template>
  <div class="container" data-testid="comments">
    <Tile
      :entityId="id"
      :entityWithCommentType="entityWithCommentType"
      initialState="add"
      data-testid="comment_addTile"
      @create="change"
    />

    <Tile
      v-for="item in comments?.toReversed()"
      :key="item.id + item.lastModificationTime"
      :entityId="id"
      :entityWithCommentType="entityWithCommentType"
      initialState="details"
      :comment="item"
      :data-testid="`comment_viewTile`"
      @delete="change"
      @update="change"
    >
    </Tile>
  </div>
</template>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
}
</style>
